import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { map, withLatestFrom } from 'rxjs/operators';
import { Action } from 'redux';
import AppState from '../../state';

import { setLocalStorageItem } from '@webapp/utils/localstorage';
import { CreateEventDraft } from '../action-creators';
import { CREATE_EVENT_DRAFT } from '../actions';
import { NoOp } from '@webapp/store/ui/action-creators';

const DRAFTS_STORAGE_KEY_PREFIX = 'event_drafts';

export const storeEventDrafts = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Action, CreateEventDraft>(CREATE_EVENT_DRAFT),
    withLatestFrom(state$),
    map(([_, state]) => {
      const artistId = state.activeProfile.id;

      if (artistId) {
        const toStore = state.traclink.tourEventDrafts;
        setLocalStorageItem(buildDraftsStorageKey(artistId), toStore);
      }

      return new NoOp();
    })
  );

export const buildDraftsStorageKey = (artistId: string) => {
  return `${DRAFTS_STORAGE_KEY_PREFIX}::${artistId}`;
};
